<template>
  <div class="rules-page">
    <div class="rules-card">
      <h1 class="rules-title">直播规范</h1>

      <div class="rules-content">
        <section class="section">
          <h2 class="section-title">一、总则</h2>
          <p class="section-text">
            1. 本规范适用于光星乐动平台（以下简称"本平台"）上的所有主播和用户。
            您在本平台进行直播、观看、互动等行为时，均应遵守本规范。
          </p>
          <p class="section-text">
            2. 本平台致力于打造一个健康、文明、积极的直播社区，
            禁止一切违法违规及违反公序良俗的行为。
          </p>
          <p class="section-text">
            3. 本平台有权根据法律法规及运营需要，不时修订本规范，
            修订后的规范将在平台公布，自公布之日起生效。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">二、直播内容规范</h2>
          <p class="section-text">
            主播在直播过程中，不得出现以下内容：
          </p>
          <ul class="list">
            <li>反对宪法所确定的基本原则的；</li>
            <li>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
            <li>损害国家荣誉和利益的；</li>
            <li>煽动民族仇恨、民族歧视，破坏民族团结的；</li>
            <li>破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
            <li>散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
            <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
            <li>侮辱或者诽谤他人，侵害他人合法权益的；</li>
            <li>含有法律、行政法规禁止的其他内容的。</li>
          </ul>
        </section>

        <section class="section">
          <h2 class="section-title">三、主播行为规范</h2>
          <p class="section-text">
            1. 主播应当遵守法律法规，文明直播，不得传播低俗、庸俗、媚俗内容。
          </p>
          <p class="section-text">
            2. 主播不得穿着暴露、举止不雅，不得进行任何具有性暗示或挑逗性的表演。
          </p>
          <p class="section-text">
            3. 主播不得在直播中进行赌博、诈骗、传销等违法活动。
          </p>
          <p class="section-text">
            4. 主播不得引导用户进行线下交易，不得私自收取用户财物。
          </p>
          <p class="section-text">
            5. 主播应当积极维护直播间秩序，及时处理违规言论和行为。
          </p>
          <p class="section-text">
            6. 主播不得使用虚假身份或冒充他人进行直播。
          </p>
          <p class="section-text">
            7. 主播不得在直播中展示、销售违禁物品或假冒伪劣商品。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">四、用户互动规范</h2>
          <p class="section-text">
            1. 用户在观看直播、发送弹幕、评论时，应当文明用语，尊重他人。
          </p>
          <p class="section-text">
            2. 禁止发送以下内容：
          </p>
          <ul class="list">
            <li>辱骂、攻击、威胁他人的言论；</li>
            <li>散布谣言、虚假信息的内容；</li>
            <li>发布广告、恶意刷屏的内容；</li>
            <li>涉及色情、暴力、恐怖的内容；</li>
            <li>其他违反法律法规和公序良俗的内容。</li>
          </ul>
          <p class="section-text">
            3. 用户不得利用礼物、弹幕等功能进行恶意骚扰或欺诈。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">五、未成年人保护</h2>
          <p class="section-text">
            1. 本平台禁止未满18周岁的未成年人进行直播。
            如发现未成年人直播，平台将立即封禁直播间。
          </p>
          <p class="section-text">
            2. 平台将对未成年人的观看行为进行限制，包括直播时段、消费金额等。
          </p>
          <p class="section-text">
            3. 家长和监护人应当加强对未成年人使用本平台的监督和引导。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">六、违规处理</h2>
          <p class="section-text">
            1. 对于违反本规范的行为，平台将根据情节轻重采取以下措施：
          </p>
          <ul class="list">
            <li>警告并要求整改；</li>
            <li>封禁直播间（1天、7天、30天或永久）；</li>
            <li>扣除违规收益；</li>
            <li>冻结账号或永久封禁；</li>
            <li>涉嫌违法犯罪的，移交公安机关处理。</li>
          </ul>
          <p class="section-text">
            2. 用户对违规处理有异议的，可向平台客服申诉。
            平台将在收到申诉后及时核实并回复。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">七、内容审核</h2>
          <p class="section-text">
            1. 平台有权对直播内容进行实时审核和事后审核。
          </p>
          <p class="section-text">
            2. 平台有权对违规内容进行删除、屏蔽或中断直播。
          </p>
          <p class="section-text">
            3. 平台鼓励用户积极举报违规行为，共同维护良好的社区环境。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">八、免责声明</h2>
          <p class="section-text">
            1. 主播对其直播内容承担全部法律责任，平台不对主播内容的合法性、真实性负责。
          </p>
          <p class="section-text">
            2. 用户在观看直播过程中因自身原因产生的损失，平台不承担责任。
          </p>
          <p class="section-text">
            3. 因不可抗力导致的服务中断或数据丢失，平台不承担责任。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">九、联系我们</h2>
          <p class="section-text">
            如您对本直播规范有任何疑问或建议，或需要举报违规行为，请通过以下方式联系我们：
          </p>
          <p class="section-text">
            公司名称：北京光星影月文化传媒有限公司
          </p>
          <p class="section-text">
            办公地址：北京市丰台区方庄南路15号楼7层1座808-51室
          </p>
          <p class="section-text">
            邮箱：guangxingledong@163.com
          </p>
        </section>
      </div>

      <div class="rules-footer">
        <p class="update-time">更新时间：2026年9月18日</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZbgfPage'
}
</script>

<style scoped lang="scss">
// B站直播风格令牌：粉 #fb7299 / hover #ff85ad / 浅粉 #fff0f5
// 文字 #18191c #61666d #9499a0 / 边框 #e3e5e7 / 分割 #f1f2f3 / 底 #f4f4f5

// 页面容器（由外层 .content 滚动，禁止 100vh 撑高）
.rules-page {
  min-height: 100%;
  background: #f4f4f5;
  padding: 24px 20px 32px;
  box-sizing: border-box;
}

// 规范白色卡片
.rules-card {
  max-width: 820px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 8px;
  padding: 32px 36px;
  box-sizing: border-box;
}

// 主标题
.rules-title {
  font-size: 20px;
  font-weight: 600;
  color: #18191c;
  text-align: center;
  margin: 0 0 8px;
}

// 内容区域
.rules-content {
  margin-bottom: 24px;
}

// 章节
.section {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }

  .section-title {
    position: relative;
    font-size: 16px;
    font-weight: 600;
    color: #18191c;
    margin: 0 0 12px;
    padding-left: 10px;

    // 小粉条层级标记
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 14px;
      background: #fb7299;
      border-radius: 2px;
    }
  }

  .section-text {
    font-size: 14px;
    color: #61666d;
    line-height: 1.8;
    margin: 0 0 8px;
    text-align: justify;
  }

  // 保留默认序号样式，避免全局 reset 影响
  .list {
    list-style: disc;
    margin: 8px 0;
    padding-left: 24px;

    li {
      font-size: 14px;
      color: #61666d;
      line-height: 1.8;
      margin-bottom: 4px;
      padding-left: 2px;
    }
  }
}

// 底部区域
.rules-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #f1f2f3;

  .update-time {
    font-size: 12px;
    color: #9499a0;
    margin: 0;
  }
}
</style>
